/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'equipmentLedger': {
    width: 16,
    height: 16,
    viewBox: '0 0 15 15',
    data: '<path pid="0" class="st0" d="M15 4.5L10.8.3 9.6 3.7 7 6.4 5.8 5.2 4.4 3.8l-.7.7 1.4 1.4-4.2 4.2c-.8.8-.8 2 0 2.8l1.4 1.4c.8.8 2 .8 2.8 0l4.2-4.2 1.4 1.4.7-.7L10 9.4 8.8 8.2l2.7-2.7 3.5-1zM4.4 13.7c-.4.4-1 .4-1.4 0l-1.4-1.4c-.4-.4-.4-1 0-1.4l4.2-4.2 2.8 2.8-4.2 4.2z"/><path pid="1" transform="rotate(-45.001 3.303 11.889)" class="st0" d="M2.8 10.9h1v2h-1z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/equipmentLedger.js